<template>
  <div class="sidebar-account">
    <div class="text lead mb-0">
      <span class="mr-2">{{ getInitials() }}</span>
    </div>
    <p class="text text-muted mb-2">{{ getDepartments() }}</p>
    <p class="text text-muted mb-0">{{ getRoles() }}</p>

    <p></p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { userMappers } from '@/store/modules/user'
import { rolesTranslation } from '@/config/roles'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['currentUser', 'userRoles', 'userDepartments'])
  }
})

@Component
export default class Profile extends Mappers {
  private getInitials() {
    return this.currentUser && this.currentUser.initials
      ? this.currentUser.initials
      : 'Неизвестный'
  }

  private getRoles() {
    return this.userRoles.map((r: string) => rolesTranslation[r]).join(', ')
  }
  private getDepartments() {
    return this.userDepartments
      .filter((d: any) => d.workDepartment)
      .map((d: any) => d.workDepartment.shortTitle)
      .join(', ')
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.text {
  padding: 0rem 1rem;
}
</style>
